import ScheduleInvoiceRetryActionModel
    from '@/common/models/rules/actions/schedule-invoice-retry-action-model';

export default class InvoiceRetryInstructionModel extends ScheduleInvoiceRetryActionModel {
    getPayload() {
        const payload = super.getPayload();
        Reflect.deleteProperty(payload, 'overrideRetryInstruction');
        return payload;
    }
}
